export default __webpack_public_path__ + "static/media/Healthwise Data logo-no background.915b9ea1.svg";